export default __webpack_public_path__ + "images/phi_fff600.png";